import { ImageType, ProductType } from '@/shared/enums';
import { fitObject, getSecureUrl } from '@/shared/utils';
import querystring from 'querystring';
import { defaultImage } from '@/index/shared/filters';
import viewportMixin from './viewport-mixin';

const ImageState = {
  DEFAULT: 'DEFAULT',
  FALLBACK: 'FALLBACK',
  PLACEHOLDER: 'PLACEHOLDER',
};

export default {
  mixins: [
    viewportMixin,
  ],
  data() {
    return {
      imageSrc: null,
      imageState: ImageState.PLACEHOLDER,
      liveManager: this.$services.resolve('liveManager'),
    };
  },
  computed: {
    productSrc() {
      let src = this.getSrcForProduct(this.product, this.type);

      if (!src && this.product.type === ProductType.PROGRAMME && this.product.channelId) {
        const channels = this.liveManager.channels.collection.records;
        const channel = channels.find(({ id }) => this.product.channelId === id);
        src = this.getSrcForProduct(channel, ImageType.ARTWORK);
      }

      if (!src) {
        return getSecureUrl(this.placeholderSrc);
      }

      const [srcUrl, srcQuery] = src.split('?');
      const query = querystring.parse(srcQuery);

      if (query.dstw > window.screen.width) {
        const { width, height } = fitObject({ width: query.dstw, height: query.dsth }, window.screen);

        query.dstw = width;
        query.dsth = height;
        src = srcUrl + '?' + querystring.stringify(query);
      }

      return getSecureUrl(src);
    },
    placeholderSrc() {
      return defaultImage(this.product, { onlyUrl: true });
    },
  },
  watch: {
    type() {
      this.loadImage();
    },
    product() {
      this.imageSrc = '';
      this.$nextTick(() => {
        this.load();
      });
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    getProperty(source = {}, type, property) {
      return source[type] && source[type].length && source[type][0][property];
    },
    load() {
      this.loadPlaceholder();
      this.observe();
    },
    loadImage() {
      this.imageState = ImageState.DEFAULT;
      this.imageSrc = this.productSrc;
    },
    loadPlaceholder() {
      if ((this.type === ImageType.POSTER_ARTWORK || this.type === ImageType.ARTWORK) && this.imageState === ImageState.DEFAULT) {
        this.imageState = ImageState.FALLBACK;
        this.imageSrc = this.getProperty(this.product.images, '16x9', 'mainUrl');
        return;
      }

      this.imageState = ImageState.PLACEHOLDER;
      this.imageSrc = this.placeholderSrc;
    },
    onViewportEnter() {
      this.unobserve();
      this.loadImage();
    },
    getSrcForProduct(product, type) {
      const logo = product.logo?.images;
      const images = product.images;
      const artworks = product.artworks;

      switch (type) {
        case ImageType.ARTWORK:
          return this.getProperty(artworks, '16x9', 'mainUrl') || this.getProperty(images, '16x9', 'mainUrl');
        case ImageType.COVER:
          return this.getProperty(images, '16x9', 'mainUrl');
        case ImageType.COVER_MINI:
          return this.getProperty(images, '16x9', 'miniUrl');
        case ImageType.HORIZONTAL_POSTER:
          return this.getProperty(images, '5x4', 'mainUrl');
        case ImageType.LOGO:
          return this.getProperty(logo, '16x9', 'mainUrl');
        case ImageType.POSTER:
          return this.getProperty(images, '3x4', 'miniUrl');
        case ImageType.POSTER_ARTWORK:
          return this.getProperty(images, '3x4', 'miniUrl') || this.getProperty(images, '16x9', 'mainUrl');
        case ImageType.LANDSCAPE:
          return this.getProperty(images, '3x1', 'mainUrl');
        case ImageType.SQUARE:
          return this.getProperty(images, '1x1', 'mainUrl');
        case ImageType.SQUARE_MINI:
          return this.getProperty(images, '1x1', 'miniUrl');
      }
    },
  },
};
